"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hourlabelrow_1 = __importDefault(require("./hourlabelrow"));
var hourrow_1 = __importDefault(require("./hourrow"));
var enums_1 = require("./types/enums");
var heatmapdatastore_1 = __importDefault(require("./classes/heatmapdatastore"));
var styled_components_1 = __importDefault(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 1px solid rgb(0 0 0 / 16%);\n    border-radius: 4px;\n    line-height: 1;\n"], ["\n    border: 1px solid rgb(0 0 0 / 16%);\n    border-radius: 4px;\n    line-height: 1;\n"])));
var Heatmap = function (_a) {
    var data = _a.data, popup = _a.popup, colors = _a.colors, domain = _a.domain, valueColumn = _a.valueColumn, dateColumn = _a.dateColumn;
    var d = heatmapdatastore_1.default.fromRows({ rows: data, dateColumn: dateColumn, valueColumn: valueColumn });
    var ds = new heatmapdatastore_1.default(__assign(__assign({}, d), { popup: popup, colors: colors, domain: domain }));
    return (react_1.default.createElement(Container, { className: "tooltipBoundary" },
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.M, data: ds.M, scale: ds.scale, index: 0, popup: popup }),
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.T, data: ds.T, scale: ds.scale, index: 1, popup: popup }),
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.W, data: ds.W, scale: ds.scale, index: 2, popup: popup }),
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.Th, data: ds.Th, scale: ds.scale, index: 3, popup: popup }),
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.F, data: ds.F, scale: ds.scale, index: 4, popup: popup }),
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.Sa, data: ds.Sa, scale: ds.scale, index: 5, popup: popup }),
        react_1.default.createElement(hourrow_1.default, { dayOfWeek: enums_1.DayOfWeek.Su, data: ds.Su, scale: ds.scale, index: 6, popup: popup }),
        react_1.default.createElement(hourlabelrow_1.default, null)));
};
exports.default = Heatmap;
var templateObject_1;
